import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import useWindowSize from '../../../utils/useWindowSize';
import { Container, Headline, sizes } from '../ui/common';
import ImageSlider from '../ImageSlider';
import {
  Section,
  Wrap,
  ImageWrapper,
  Picture,
  List,
  Block,
  Image,
} from './styled';

function Gallery({ images }) {
  const size = useWindowSize();
  const [activeSlideIndex, setActiveSlideIndex] = useState(0);

  const isTablet = size.width > sizes.phone && size.width <= sizes.tablet;
  const isDesktop = size.width > sizes.tablet;
  const Wrapper = size.width < sizes.medium ? Wrap : Container;

  return (
    <Section>
      <Wrapper>
        <Headline>
          <FormattedMessage id="gallery.headline" />
        </Headline>
        <ImageWrapper>
          {isTablet && <Picture image={images[activeSlideIndex]} alt="" />}
          {!isDesktop && (
            <ImageSlider
              images={images}
              activeSlideIndex={activeSlideIndex}
              setActiveSlideIndex={setActiveSlideIndex}
            />
          )}
        </ImageWrapper>
        {isDesktop && (
          <List>
            <Block>
              <Image image={images[0]} alt="" />
              <Image image={images[1]} alt="" />
              <Image image={images[2]} alt="" />
            </Block>
            <Block>
              <Image image={images[3]} alt="" />
              <Image image={images[4]} alt="" />
            </Block>
          </List>
        )}
      </Wrapper>
    </Section>
  );
}

export default Gallery;

Gallery.propTypes = {
  images: PropTypes.arrayOf(PropTypes.any),
};
Gallery.defaultProps = {
  images: [],
};
